import { getMonthFromDate } from "../../../extensions/date";
import {
  CompareRajasthan,
  RajProcurementData,
} from "../../../models/rajasthan";
import {
  getRajasthanCollectiveData,
  getRajDeep,
  getRajBankingData,
  getRajNoar,
} from "../../Rajasthan/Utility/RestApi";

export async function getProcurementData({
  startDate,
  endDate,
}: {
  startDate: string;
  endDate: string;
}): Promise<{ compareData: CompareRajasthan[]; data: RajProcurementData }> {
  // Initiate all API calls concurrently
  const [collectiveData, tamData, deepData, bankingData] = await Promise.all([
    getRajasthanCollectiveData({
      startDate: startDate,
      endDate: endDate,
    }),
    // getGnaTgnaData({ startDate: startDate, endDate: endDate }),
    getRajNoar({ startDate: startDate, endDate: endDate }),
    getRajDeep({ startDate: startDate, endDate: endDate }),
    getRajBankingData({ startDate: startDate, endDate: endDate }),
  ]);

  const processedCollectiveData = collectiveData.map((item) => {
    const isBuy = item.value_mw > 0;
    return {
      ...item,
      type: isBuy ? "Collective Buy" : "Collective Sell",
      time_block: item.time_slot,
      exchange: item.exchange__name,
      product: item.product__name,
      price_kwh: item.wt_mcp_rs_kwh,
      entity: item.exchange__name + " " + item.product__name,
      value_mwh: Math.abs(item.value_mw) / 4,
      value_mw: Math.abs(item.value_mw),
      month: getMonthFromDate(item.date),
    };
  });

  const processedTamData = tamData.map((item) => ({
    ...item,
    type: "TAM",
    exchange: item.exchange,
    product: item.product,
    value_mwh: item.mw / 4,
    value_mw: item.mw,
    time_block: item.block,
    month: getMonthFromDate(item.date),
  }));

  const processedDeepData: CompareRajasthan[] = deepData
    .map((item) => {
      return {
        ...item,
        type: `Deep`,
        exchange: "Deep",
        product: "RA",
        entity: item.entity,
        time_block: item.slot,
        toEntity: item.entity,
        value_mwh: Math.abs(item.value_mw) / 4,
        value_mw: Math.abs(item.value_mw),
        month: getMonthFromDate(item.date),
      };
    })
    .filter((item) => item.value_mw > 0);

  const processedBankingData = bankingData.map((item) => ({
    ...item,
    type: "Banking",
    exchange: "Banking",
    product: "Banking",
    value_mwh: item.mw / 4,
    value_mw: item.mw,
    time_block: item.time_block,
    month: getMonthFromDate(item.date),
  }));

  const compare = [
    ...processedCollectiveData,
    ...processedTamData,
    ...processedDeepData,
    ...processedBankingData,
  ];

  return {
    compareData: compare,
    data: {
      collective: collectiveData,
      tam: tamData,
      deep: deepData,
      bankingData: bankingData,
      compare: compare,
    },
  };
}
